var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('Loading'):_vm._e(),(_vm.warning)?_c('h2',[_vm._v("Page Not Found")]):_vm._e(),(_vm.valid)?_c('h2',[_vm._v("Invalid or expired link")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }